/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const skillSummarySchema = z.object({
  assignmentId: z.int().nullish(),
  critical: z.boolean(),
  id: z.int(),
  name: z.string(),
});
